var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgReferralReward(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#92C6EC",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.983 27.468l-11.81-9.062 15.05-6.021.809 2.049-11.452 4.582 8.731 6.704-1.328 1.748z",
    fill: "#69808C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13.766a4.786 4.786 0 01-1.379 3.381 4.725 4.725 0 01-3.355 1.4 4.656 4.656 0 01-2.866-.985 4.759 4.759 0 01-1.675-2.395 4.788 4.788 0 01.035-2.928 4.756 4.756 0 011.733-2.353A4.705 4.705 0 0126.266 9c.564-.003 1.123.1 1.649.301.907.336 1.69.944 2.241 1.743.552.799.847 1.749.844 2.722z",
    fill: "#F58787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.483 18.547a4.792 4.792 0 01-1.39 3.372 4.73 4.73 0 01-3.351 1.393 4.587 4.587 0 01-2.583-.734 4.76 4.76 0 01-1.923-2.35 4.796 4.796 0 01-.118-3.042c.292-1 .902-1.875 1.736-2.493a4.712 4.712 0 012.88-.927 4.608 4.608 0 011.992.44 4.75 4.75 0 012.01 1.764c.489.77.748 1.664.747 2.577z",
    fill: "#73D3E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.826 26.19a4.836 4.836 0 01-1.389 3.42 4.778 4.778 0 01-3.389 1.419 4.662 4.662 0 01-2.837-.947 4.803 4.803 0 01-1.515-1.886 4.837 4.837 0 01.394-4.677 4.789 4.789 0 011.809-1.602 4.75 4.75 0 014.658.202 4.797 4.797 0 011.665 1.752c.397.718.605 1.527.604 2.348v-.03z",
    fill: "#FFB54D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.726 14.206l-4.537 8.32a4.76 4.76 0 01-1.858-2.34 4.796 4.796 0 01-.104-2.993 4.766 4.766 0 011.69-2.465 4.714 4.714 0 012.818-.962 4.605 4.605 0 011.99.44z",
    fill: "#94E7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.915 9.301L23.4 17.547a4.759 4.759 0 01-1.66-2.393 4.788 4.788 0 01.04-2.918 4.756 4.756 0 011.726-2.345 4.706 4.706 0 012.76-.89c.564-.004 1.123.098 1.649.3z",
    fill: "#F99"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.777 21.712l-4.566 8.342a4.813 4.813 0 01-1.802-2.836 4.838 4.838 0 01.487-3.331 4.787 4.787 0 012.537-2.194 4.748 4.748 0 013.344.019z",
    fill: "#FFD966"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.735 21.241a2.7 2.7 0 002.691-2.71 2.7 2.7 0 00-2.691-2.709 2.7 2.7 0 00-2.692 2.71 2.7 2.7 0 002.692 2.71z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgReferralReward;